/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Email_General_DescriptionInputs */

const en_admin_settings_groups_email_general_description = /** @type {(inputs: Admin_Settings_Groups_Email_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email provider selection`)
};

/**
* | output |
* | --- |
* | "Email provider selection" |
*
* @param {Admin_Settings_Groups_Email_General_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_email_general_description = /** @type {((inputs?: Admin_Settings_Groups_Email_General_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Email_General_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_email_general_description(inputs)
});
export { admin_settings_groups_email_general_description as "admin.settings.groups.email_general.description" }